import type { NavGroupDef, NavItemDef } from '../../../navigation/menu.ts'

/** Evento con cui l'AppShell (Alt+M) chiede di portare il focus sul campo "Cerca nel menu". */
export const NAV_SEARCH_FOCUS_EVENT = 'ecrm:nav-search-focus'

const fold = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()

export interface NavSearchHit { item: NavItemDef; group: NavGroupDef }

/** Filtra le voci VISIBILI per etichetta, parole chiave ed etichetta del gruppo (senza accenti né maiuscole). */
export function searchNav(groups: NavGroupDef[], query: string): NavSearchHit[] {
  const q = fold(query)
  if (!q) return []
  const hits: NavSearchHit[] = []
  for (const group of groups) {
    const groupText = fold(group.label)
    for (const item of group.items) {
      const hay = [item.label, ...(item.keywords ?? []), item.section ?? ''].map(fold)
      if (hay.some(h => h.includes(q)) || groupText.includes(q)) hits.push({ item, group })
    }
  }
  return hits
}
